import React from "react";
import {Helmet} from "react-helmet";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
 
class New_helmet extends React.Component {
  render () {
    return (
      <React.Fragment>
            <Helmet> 
             </Helmet> 
        </React.Fragment>
    );
  }
};

New_helmet.propTypes = {
};

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, {   })(
    withRouter(New_helmet)
);


// WEBPACK FOOTER //
// ./src/components/homepage_new/New_helmet.js